import { addressCardProps } from '~/src/constants/addressCard';

import * as ST from './styled';

const AddressCard: React.FC<addressCardProps> = ({
    image, description,
    }) => {

    return (
        <ST.AddressCard className={'ym-hide-content'}>
            <ST.AddressCardImage image={image} />
            <ST.AddressCardDescription>{description}</ST.AddressCardDescription>
        </ST.AddressCard>
    );
};

export default AddressCard;
